module.exports = function (fox) {
	'use strict';

	var require__templates = require.context('fox-dynamic-injection!fox-template-loader!./templates', true, /\.tpl$/);
	var templateFiles = require__templates.keys();

	templateFiles.forEach(function (file) {
		require__templates(file)(fox);
	});
	require('./stylus/_splash.styl');
};



//////////////////
// WEBPACK FOOTER
// ./components/splash/index.js
// module id = 477
// module chunks = 4